import { apiSlice } from "./apiSlice";
export const procurementHotelSitcSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllProcurementHotelSitc: builder.query({
            query: (params) => ({
                url: `ProcurementHotelSitc`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllProcurementHotelSitcTracker"],
        }),
        getProcurementHotelSitcDetail: builder.query({
            query: (req) => ({
                url: `ProcurementHotelSitc/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addProcurementHotelSitc: builder.mutation({
            query: (body) => ({
                url: `ProcurementHotelSitc`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllProcurementHotelSitcTracker']
        }),

        editProcurementHotelSitc: builder.mutation({
            query: (body) => ({
                url: `ProcurementHotelSitc`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllProcurementHotelSitcTracker']
        }),
         deleteProcurementHotelSitc: builder.mutation({
            query: (procurementHotelSitcId) => ({
                url: `ProcurementHotelSitc/${procurementHotelSitcId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllProcurementHotelSitcTracker']
        }),
         getExportAllProcurementHotelSitc: builder.query({
            query: (params) => ({
                url: `ProcurementHotelSitc`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const {
    useLazyGetAllProcurementHotelSitcQuery,
    useEditProcurementHotelSitcMutation,
    useAddProcurementHotelSitcMutation,
    useGetAllProcurementHotelSitcQuery,
    useGetProcurementHotelSitcDetailQuery,
    useDeleteProcurementHotelSitcMutation,
    useLazyGetExportAllProcurementHotelSitcQuery
} = procurementHotelSitcSlice;
